import { render, staticRenderFns } from "./FormProject.vue?vue&type=template&id=32c5211d&scoped=true&"
import script from "./FormProject.vue?vue&type=script&lang=js&"
export * from "./FormProject.vue?vue&type=script&lang=js&"
import style0 from "./FormProject.vue?vue&type=style&index=0&id=32c5211d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c5211d",
  null
  
)

export default component.exports